import router from "../router"
import firebase from 'firebase/app'
import {API_HOST} from "@/helpers/stipe_const";
import CONST from "./constants";
import {db} from "../fb/firebase";
import {defaultUserSettings} from "./configs";

const connectToExtension = async (uid, force = false, cb = () => {}) => {
  const { Android }  = window;
  if (Android && uid) {
    Android.sendJsMsgToWebView(uid);
    localStorage.setItem('isRemote', false);
    const queryDeviceID = router.currentRoute.query.deviceid;
    if (queryDeviceID) {
      localStorage.setItem('deviceID', queryDeviceID);
      return Promise.resolve(queryDeviceID);
    } else {
      const storageDeviceID = localStorage.getItem('deviceID');
      return Promise.resolve(storageDeviceID);
    }
  }

  if (typeof window !== 'undefined' && !Android) {
    const browser = window.browser || window.chrome;
    if (browser) {
      try {
       return new Promise((resolve) => {
         browser.runtime.sendMessage(localStorage.getItem('extID'), {uid: uid, force}, (deviceID) => {
           /*    if (browser.runtime.lastError) {
                   if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium'&& router.currentRoute.path !== '/landing-flow') {
                       router.push('/login')
                   }
                   localStorage.setItem('isRemote', true)
               } else {
                   localStorage.setItem('isRemote', false)
                   // router.push('/')
               }*/
           cb(deviceID)
           resolve(deviceID);
         });
       }).catch((er) => {
         console.log(er);
         return false;
        });
      } catch (e) {
        /**
         * @if extension with id doesn't exist redirect to login, remove loader
         */
        console.warn(e)
        localStorage.setItem('isRemote', true);
        if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium' && router.currentRoute.path !== '/landing-flow'  && router.currentRoute.path !== '/removed') {
          router.push('/login');
        }
        cb()
        return true;
      }
    } else { //firefox
      console.log('firefox');
      if (document.body.classList.contains('ext-installed')) {
        window.addEventListener("message", (event) => {
          if (event.data && event.data.direction === "from-content-script" && event.data.connectedToExt) {
            localStorage.setItem('isRemote', false);
            cb();
          }
        });
        window.postMessage({
          direction: 'from-page-script',
          message: 'connect to extension',
          uid,
          force,
        }, '*');
      } else {
        localStorage.setItem('isRemote', true);
        if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/premium') {
          router.push('/login');
        }
        cb();
      }
    }
  }
}

const checkDBState = async (userUid) => {
  return db.ref('users/' + userUid)
    .get()
    .then((snapshot) => {
      if (snapshot.exists()) {
        const dateString = new Date().toDateString();
        const profiles = snapshot.val().settings.profiles;
        Object.keys(profiles).forEach(profileName => {
          if (profiles[profileName].resetDate !== dateString && profileName !== 'guestProfileAtCurrentDevice') {
            const updates = {};
            updates['/resetDate'] = dateString;
            updates['/todayDailyLimit'] = profiles[profileName].dailyLimit;
            updates['/dailyLimitUsed'] = 0;
            db.ref('users/' + userUid + '/settings/profiles/' + profileName).update(updates);
          }
        });
      } else {
        return db.ref('users/' + userUid).set({
          settings: defaultUserSettings,
        }).then(() => {
          console.log('created');
        });
      }
    }).catch((error) => {
    console.error(error);
  });
}

function loginWithToken(userUId) {
  fetch(`${CONST.API_URL}createToken?uid=${userUId}`).then(
    function (res) {
      if (res.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + res.status);
        return;
      }

      // Examine the text in the response
      res.json().then(function (data) {
        firebase.auth().signInWithCustomToken(data.uid)
          .then((userCredential) => {
            console.log('logged', userCredential);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }
  )
}

function getQueryParameterByName(name, url = window.location.href) {
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function checkIfAndroid(){
  return /(android)/i.test(navigator.userAgent)
}

function reportEvent(eventName, propertyName) {
  if (process.env.NODE_ENV === 'development') {
    console.log(eventName, propertyName);
  } else {
    const labelData = {};
    const labelDataArr = [];
    if (propertyName) {
      for (const [key, value] of Object.entries(propertyName)) {
        labelData[`${key}`] = `${value}`
      }
    }
    if (checkIfAndroid()) {
      labelData['isAndroid'] = true
    }
    if (localStorage.getItem('firebaseUserId')) {
      labelData['firebaseUserId'] = localStorage.getItem('firebaseUserId');
    }
    labelDataArr.push(labelData);

    const formData = new FormData()
    formData.append('a', eventName);
    formData.append('l', JSON.stringify(labelDataArr));

    if (propertyName && propertyName.firebaseUserId) {
      formData.append('fb', propertyName.firebaseUserId);
    }

    fetch('https://kidsmode.net/r/', {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'same-origin',
      body: formData
    });
  }
}

function sendRegistrationEmail(email){
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({'email': email})
  };
  fetch(`${API_HOST}/api/registration-user`, options).then(data => {
    if (!data.ok) {
      throw Error(data.status);
    }
    return data.json();
  }).catch(e => {
    console.log(e);
  });
}

function getTimeStamp(cb){
  firebase.database().ref( '.info/serverTimeOffset' ).once( 'value', function( snap ) {
    const offset = snap.val();
    // Get server time by milliseconds
    cb( new Date().getTime() + offset );
  });
}

function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const getMDY = (timeStamp, daysOffset = 0) => {
  let d = new Date(timeStamp);
  d.setDate(d.getDate() + daysOffset);
  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`
}

function formatAMPM(timeStamp) {
  const date = new Date(timeStamp);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return hours + ':' + minutes + ' ' + ampm;
}

function convertAMPMToTime(string, base) {
  const numbers = string.split(' ')[0].split(':');
  const isMid = parseInt(numbers[0]) === 12;
  let hours = parseInt(numbers[0]) + ((string.includes('PM') && !isMid) ? 12 : 0);
  if (string.includes('AM') && isMid) {
    hours = hours - 12;
  }
  const minutes = parseInt(numbers[1]);
  return new Date(base.getFullYear(), base.getMonth(), base.getDate(), hours, minutes);
}

function isProfileTimeUnAvailable(availableTime) {
  const currentDate = new Date();
  const dayOfTheWeek = currentDate.getDay();
  const periods = availableTime[dayOfTheWeek].periods;

  if (availableTime[dayOfTheWeek].isActive) {
    const timeStamps = [];
    periods && periods.forEach(period => {
      const { from, to } = period;
      const temp = {}
      temp.from = convertAMPMToTime(from, currentDate);
      temp.to = convertAMPMToTime(to, currentDate);
      timeStamps.push(temp);
    })

    const isUnavailable = timeStamps.some(stamp => currentDate > stamp.from && currentDate < stamp.to);
    const unAvailableValue = availableTime[dayOfTheWeek].allDay || isUnavailable;
    console.log(unAvailableValue, 'unAvailableValue');

    return !!unAvailableValue;
  }
  return false;
}

const hitFCMessage = (fcmToken) => {
  const data = {
    "data": {
      "title": "hello",
      "message": "test message"
    },
    "registration_ids": fcmToken,
    "priority": "high"
  };

  fetch('https://fcm.googleapis.com/fcm/send', {
    method: 'POST',
    headers: new Headers({
      'Authorization': 'key=AAAA1gGtnBs:APA91bG-7jA4sQVW5rt5nm40BqxomZBIKSYY_dW5iKW_QLM9vvnqUobbyHpbLi6aMl7N-AHpJkse1B28JQwt6VGMqbUKSTa94hO_AngzljAcuoAvJU3bvuIP0i9P3TsEjLJEZdeuiS6X',
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(data)
  }).then(res => {
    if (!res.ok) {
      throw Error(res.status);
    }
    return res.json();
  }).then(data => {
    console.log(data);
  });
};

const getDomainFromUrl = (url) => {
  const { hostname } = new URL(url);
  return hostname;
};

function isValidURL(str) {
  const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

function isFourDigit(pass) {
  return /^[0-9]+$/.test(pass) && pass.length === 4
}

function getSessionDuration(timestamp) {
  const fullSeconds = Math.floor((new Date().getTime() - timestamp)/1000);
  return `${Math.floor(fullSeconds/60)} minutes, ${fullSeconds % 60} seconds`
}


export {
  connectToExtension,
  reportEvent,
  getTimeStamp,
  sendRegistrationEmail,
  getQueryParameterByName,
  getMDY,
  getCookie,
  hitFCMessage,
  checkDBState,
  getDomainFromUrl,
  isValidURL,
  isFourDigit,
  loginWithToken,
  formatAMPM,
  convertAMPMToTime,
  isProfileTimeUnAvailable,
  getSessionDuration
}